import * as BranchesDetailsConstants from './branches-details.constants';

export default BranchesDetailsConstants;
